import { useTranslation } from 'react-i18next';
import { cn } from '@shared/utils';
import { SidebarRow } from '@widgets';
import { Text } from '@shared/widgets';

interface LimitRowProps {
  className?: string;
  label: string;
  symbol: string;
  currentAmount: number;
  limitAmount: number;
  currentNumber: number;
  limitNumber: number;
}

export const LimitRow = (props: LimitRowProps) => {
  const { t } = useTranslation('card');

  return (
    <div className={cn('flex flex-col gap-2', props.className)}>
      <Text>{props.label}</Text>
      <SidebarRow
        className='mb-0'
        label={t('sidebar.limits.fields.usedAmount')}
        value={props.symbol ? props.symbol + props.currentAmount + '/' + props.symbol + props.limitAmount : undefined}
      />
      <SidebarRow className='mb-0' label={t('sidebar.limits.fields.usedTxnNumber')} value={props.currentNumber + '/' + props.limitNumber} />
    </div>
  );
};
